module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "ui segment"
  }, [_vm._h('h2', {
    staticClass: "ui header"
  }, ["Sign In"]), " ", _vm._h('div', {
    staticClass: "ui google plus button",
    on: {
      "click": _vm.signIn
    }
  }, [_vm._h('i', {
    staticClass: "google plus icon"
  }), "\n    Sign In With Google+\n  "])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ea21a02!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignIn.vue
// module id = 238
// module chunks = 2